import DefaultBlock from "/scripts/default/block";
import gsap from "gsap";
import { watchPreferredMotion } from "/utils/helpers/watchPreferredMotion";
import { MorphSVGPlugin } from "gsap/MorphSVGPlugin";
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";
import { GSDevTools } from "gsap/GSDevTools";

gsap.registerPlugin(MorphSVGPlugin, DrawSVGPlugin, GSDevTools);

export default class UIIntro extends DefaultBlock {
	init() {
		this.DOM = {
			svg: this.block.querySelector("#ui-intro-flair"),
			text_1: this.block.querySelector("#text_1"),
			text_2: this.block.querySelector("#text_2"),
			text_3: this.block.querySelector("#text_3"),
			text_4: this.block.querySelector("#text_4"),
			image_top: this.block.querySelector("#image_top"),
			image_bottom: this.block.querySelector("#image_bottom"),
			divider_1: this.block.querySelector("#divider_1"),
			divider_2: this.block.querySelector("#divider_2"),
			divider_3: this.block.querySelector("#divider_3"),
			circle_loader: this.block.querySelector("#circle_loader"),
			circle: this.block.querySelector("#circle"),
			hamburger: this.block.querySelector("#hamburger"),
			flair: this.block.querySelector("#flair"),
			mask: this.block.querySelector("#ui-intro"),
			mask_1: this.block.querySelector("#mask_1"),
			mask_1Path: this.block.querySelector("#mask_1 path"),
			mask_2Path: this.block.querySelector("#mask_2 path"),
			mask_3Path: this.block.querySelector("#mask_3 path"),
			mask_4Path: this.block.querySelector("#mask_4 path"),
			footer: this.block.querySelector("#intro_footer"),
		};

		this.animate();
	}

	animate() {
		gsap.set(this.DOM.svg, { autoAlpha: 1 });

		watchPreferredMotion(() => {
			const svgWidth = 766;
			const hamburgerRadius = 35;
			const initialTransformOrigin = `${
				((svgWidth - hamburgerRadius) / svgWidth) * 100
			}% ${(hamburgerRadius / svgWidth) * 100}%`;

			gsap.set(this.DOM.mask, {
				x: -348,
			});
			gsap.set(this.DOM.hamburger, {
				x: 12,
			});
			gsap.set(this.DOM.mask, {
				clipPath: "url(#mask_1)",
			});
			gsap.set(this.DOM.footer, {
				y: -225,
			});

			const tl = gsap
				.timeline({
					id: "ui-intro",
					defaults: {
						ease: "power3.inOut",
						duration: 0.2,
					},
					scrollTrigger: {
						trigger: this.DOM.svg,
						start: "top 85%",
					},
				})
				.to(this.DOM.mask, {
					scale: 0.8,
					transformOrigin: initialTransformOrigin,
					ease: "power3.out",
					duration: 0.2,
				})
				.to(this.DOM.mask, {
					scale: 1,
					transformOrigin: initialTransformOrigin,
					ease: "power3.out",
					duration: 0.2,
				})
				.to(this.DOM.mask, {
					x: 0,
					ease: "bounce.out",
					duration: 0.7,
				})
				.to(
					this.DOM.mask_1Path,
					{
						morphSVG: this.DOM.mask_2Path.getAttribute("d"),
						ease: "bounce.out",
						duration: 0.7,
					},
					"<"
				)
				.from(
					this.DOM.circle_loader,
					{
						drawSVG: "0%",
					},
					">-0.15"
				)
				.from(
					this.DOM.circle,
					{
						scale: 0,
						transformOrigin: "50% 50%",
						duration: 0.3,
					},
					">-0.1"
				)
				.to(
					this.DOM.mask_1Path,
					{
						morphSVG: this.DOM.mask_3Path.getAttribute("d"),
						ease: "bounce.out",
						duration: 0.5,
					},
					">-0.1"
				)
				.from(
					[this.DOM.divider_2, this.DOM.divider_1],
					{
						scaleX: 0,
						transformOrigin: "0% 50%",
					},
					"<"
				)
				.from(
					this.DOM.divider_3,
					{
						scaleY: 0,
						transformOrigin: "50% 100%",
					},
					"<"
				)
				.from(
					[
						this.DOM.image_top,
						this.DOM.image_bottom,
						this.DOM.text_3,
						this.DOM.text_4,
					],
					{
						scale: 0,
						transformOrigin: "50% 50%",
						stagger: 0.05,
					}
				)
				.from(
					this.DOM.flair,
					{
						scale: 0,
						transformOrigin: "50% 50%",
						duration: 0.4,
					},
					"<"
				)
				.to(this.DOM.footer, {
					y: 0,
					ease: "bounce.out",
					duration: 0.5,
				})
				.to(
					this.DOM.mask_1Path,
					{
						morphSVG: this.DOM.mask_4Path.getAttribute("d"),
						ease: "bounce.out",
						duration: 0.5,
					},
					"<"
				)
				.from([this.DOM.text_1, this.DOM.text_2], {
					scale: 0,
					transformOrigin: "50% 50%",
					stagger: 0.05,
					duration: 0.3,
				});

			// GSDevTools.create();
		});
	}
}
